import classnames from "classnames"
import React, { useEffect, useState } from "react"
import { getArrayToString, getStringToArray } from "../../../../utils"
import Checkbox from "../../../common/Checkbox"
import "./styles.css"

const OtherProductsList = ({ otherProductsList = [], selectedOtherProducts, getCheckedOtherProducts, unlistedotherProductsInputLabel, type, productsList = [] }) => {
  const [checkedItems, setCheckedItem] = useState([])
  const [notListedOtherProducts, setNotListedOtherProducts] = useState("")
  const otherProductsListSet1 = otherProductsList.slice(0, Math.ceil(otherProductsList.length / 2));
  const otherProductsListSet2 = otherProductsList.slice(Math.ceil(otherProductsList.length / 2));

  useEffect(() => {
    if (selectedOtherProducts.length) {
      const selectedProductArray = getStringToArray(selectedOtherProducts)
      const checkedProductArray = otherProductsList.filter(product => selectedProductArray.find(selectedP => selectedP.toLowerCase() === product.description.toLowerCase()))
      let notListedProductArray = selectedProductArray.filter(product => !checkedProductArray.find((checked) => checked.description.toLowerCase() === product.toLowerCase()))
      setNotListedOtherProducts(getArrayToString(notListedProductArray))
      notListedProductArray = getNotListedProductArrayOfObject(notListedProductArray)
      setCheckedItem(checkedProductArray)
      getCheckedOtherProducts([...checkedProductArray, ...notListedProductArray])
    }
  }, [selectedOtherProducts])

  const handleChangeCheckbox = (event, product) => {
    const checked = event.target.checked
    let items = []
    if (checked) {
      items = [...checkedItems, product]
    } else {
      items = checkedItems.filter(item => item.id !== product.id)
    }
    setCheckedItem(items)
    if (notListedOtherProducts) {
      items = [...items, ...getNotListedProductArrayOfObject(getStringToArray(notListedOtherProducts))]
    }
    getCheckedOtherProducts(items)
  }

  const handleNotlistedProduct = () => {
    let value = notListedOtherProducts
    let selectedProducts = checkedItems
    value = value.replace(/\s\s+/g, ' ')
    if (value) {
      selectedProducts = [...selectedProducts, { id: value, name: value, description: value, type: "unlistedOtherProducts" }]
    }
    getCheckedOtherProducts(selectedProducts)
  }

  const getNotListedProductArrayOfObject = (arr = []) => {
    return arr.map(value => ({ id: value, name: value, description: value, type: "unlistedOtherProducts" }))
  }

  return (
    <div className='other-products-list-wrapper'>
      <div className={type ? "other-products-list edit-product" : "other-products-list"}>
        <div className="other-products-list__left-section gdocs-float-left other-product-checkbox-container-wrapper">
          <OtherProductsNestedCheckbox otherProductsList={otherProductsListSet1} checkedItems={checkedItems}
            handleChangeCheckbox={handleChangeCheckbox} productsList={productsList}></OtherProductsNestedCheckbox>
        </div>
        <div className="other-products-list__right-section gdocs-float-right other-product-checkbox-container-wrapper">
          <OtherProductsNestedCheckbox otherProductsList={otherProductsListSet2} checkedItems={checkedItems}
            handleChangeCheckbox={handleChangeCheckbox} productsList={productsList}></OtherProductsNestedCheckbox>
        </div>
        <div className="gdocs-clear-float"></div>
      </div>
      <div className="form-row">
        <div >
          <label style={{ paddingLeft: 0 }}>{unlistedotherProductsInputLabel}</label>
        </div>
        <div >
          <input
            type="text"
            name="unlistedProduct"
            value={notListedOtherProducts && notListedOtherProducts}
            onChange={e => {
              setNotListedOtherProducts(e.target.value)
            }}
            onBlur={() => handleNotlistedProduct()}
          />
        </div>
      </div>
    </div>
  )
}

const OtherProductsNestedCheckbox = ({ otherProductsList = [], checkedItems, handleChangeCheckbox, productsList }) => (
  otherProductsList.map(product => (
    <div className={productsList.find(el => (typeof el.description === "string" && el.description.split(" ")[0]) === product.description) ? "other-product-checkbox-container disabled" : "other-product-checkbox-container"} key={product.id}>
      <Checkbox
        tabIndex={productsList.find(el => (typeof el.description === "string" && el.description.split(" ")[0]) === product.description) ? -1 : ''}
        id={product.id}
        onChange={(event) => {
          handleChangeCheckbox(event, product)
        }}
        type="checkbox"
        checked={checkedItems.find(item => item.id === product.id)}
        name={product.id}
        controlled
        className={classnames({ 'disable-item': checkedItems.find(item => item.id === product.id) })}
      />
      <label htmlFor={product.id} className={classnames({ 'disable-item': checkedItems.find(item => item.id === product.id) })}>{`${product.description} - ${product.name}`}</label>
    </div>)
  ))

export default OtherProductsList


// WEBPACK FOOTER //
// ./src/components/CaseBody/Modals/OtherProductsListModal/otherProductsList.js